import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PRINCIPLES = [
  ["We listen before we recommend.", "Understanding comes first. Conclusions come later, and only when the evidence supports them."],
  ["We respect renters.", "Renters' experiences are real, varied, and worth understanding on their own terms."],
  ["We respect landlords.", "Housing providers' experiences are equally real and equally welcome here."],
  ["We believe transparency builds trust.", "Open methods and honest data earn the confidence of everyone we work with."],
  ["We follow evidence.", "We go where the data leads, not where opinion or pressure points."],
  ["We welcome disagreement.", "Differing views make our understanding sharper, not weaker."],
  ["We protect privacy.", "Individual stories stay private. Identities are never published without permission."],
  ["We improve ideas through research.", "Better questions and better data lead to better policy discussions."],
];

export default function OurPrinciplesPage() {
  return (
    <div className="min-h-screen bg-white font-body text-ink">
      <Header />

      <section className="mx-auto max-w-7xl px-6 pb-12 pt-20 md:px-12 md:pt-28">
        <div className="text-xs uppercase tracking-[0.2em] text-cardinal">
          Our principles
        </div>
        <h1 className="mt-4 max-w-3xl font-serif text-5xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
          The commitments that guide our work.
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-700">
          These are not slogans. They are the standards we hold ourselves to in every
          conversation, every dataset, and every word we publish. We invite both renters and
          housing providers — and we hold ourselves to the same principles for each.
        </p>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-32 md:px-12">
        <div className="grid grid-cols-1 gap-px bg-slate-200 md:grid-cols-2">
          {PRINCIPLES.map(([title, desc], i) => (
            <div
              key={title}
              data-testid={`principle-${i + 1}`}
              className="flex gap-6 bg-white p-8 md:p-10"
            >
              <span className="font-mono text-sm text-calblue">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-serif text-2xl font-medium leading-snug text-ink">
                  {title}
                </h3>
                <p className="mt-2 leading-relaxed text-slate-600">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 border-l-2 border-navy pl-6">
          <p className="max-w-2xl font-serif text-2xl font-normal leading-snug text-ink md:text-3xl">
            We are not collecting stories to prove a point. We are collecting stories to
            understand the problem.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
